import React from "react";
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ListGroup from 'react-bootstrap/ListGroup';
import Tab from 'react-bootstrap/Tab';
import Nav from 'react-bootstrap/Nav';
import { entityActions } from "../../actions";
import { LocationNumberConfirm } from "./LocationNumberConfirm";

export class LocationBuildingEngine extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            search: "",
            value: props.value || "",

            // modal + numero
            open: false,
            street_number: "",
            googleCantFindStreetNumber: false,

            filter: {
                street_number: "short_name",
                route: "long_name",
                locality: "long_name",
                administrative_area_level_2: "short_name",
                country: "long_name",
                postal_code: "short_name"
            },
            hasStreet: false,
            typingTimeout: 0,
            beforeTypingTimeout: 0,

            x: 0,
            y: 0,
            route: "",
            streetId: -1,
            buildingId: -1,

            buildingName: ""
        };

        this.handleSelectStreet = this.handleSelectStreet.bind(this);
    }
    /*
    componentWillReceiveProps(nextProps) {
      // You don't have to do this check first, but it can help prevent an unneeded render
      if (nextProps.value !== this.state.value)
        this.setState({ value: nextProps.value });
    }
    */

    handleChange = (name) => (event) => {
        event.preventDefault();
        const v = event.target.value;

        if (name === "street_number") {
            const trimmed = String(v ?? "").trim();
            this.setState({
                street_number: v,
                hasStreet: trimmed !== "",
                googleCantFindStreetNumber: false
            });
            return;
        }

        this.setState({ [name]: v });
    };


    handleOpen = (open = true) => {
        this.setState({ open });
    };

    handleClose = () => event => {
        event.preventDefault();

        const num = String(this.state.street_number ?? "").trim();
        if (!num) {
            this.setState({ googleCantFindStreetNumber: true, open: true });
            return;
        }

        const street = { ...(this.state.street || {}) };
        street.Numero = num;

        this.handleSelectStreet(street);
    };

    handleSearchStreet = (e) => {
        e.preventDefault();

        const self = this;
        if (self.state.beforeTypingTimeout) clearTimeout(self.state.beforeTypingTimeout);
        if (self.state.typingTimeout) clearTimeout(self.state.typingTimeout);

        const typed = e.target.value;

        self.setState({
            search: typed,
            hasStreet: false,
            street_number: "",
            googleCantFindStreetNumber: false,
            beforeTypingTimeout: setTimeout(() => {
                self.props.onSearchGecorStreet(undefined, typed);
            }, 100),
            typingTimeout: setTimeout(() => {
                self.props.onSearchGecorStreet(typed);
            }, 500)
        });
    };

    handleSelectStreet = (street) => {
        const self = this;

        if (!street?.Numero) {
            this.setState(
                {
                    open: true,
                    googleCantFindStreetNumber: false,
                    street,
                    street_number: ""
                },
                () => self.handleOpen(true)
            );
            return;
        }

        this.handleOpen(false);

        const addressValue = `${street.TipoVia || ""} ${street.Nombre || ""} ${street.Numero || ""} ${street.Bis || ""}`
            .replace(/\s+/g, " ")
            .trim();

        this.setState(
            {
                googleCantFindStreetNumber: false,
                open: false,

                search: "",
                route: street.Nombre,
                street_number: street.Numero || 0,
                hasStreet: true,

                x: 0,
                y: 0,
                streetId: street.CalleID || -1,
                buildingId: street.EdificioID || -1,
            },
            () => {
                self.props.onSuccessLocation({
                    x: self.state.x,
                    y: self.state.y,
                    value: addressValue,            // dirección
                    route: street.Nombre,
                    street_number: street.Numero || 0,
                    streetId: street.CalleID || -1,
                    buildingId: street.EdificioID || -1,
                    buildingName: ""                // edificio vacío
                });
                self.props.dispatch(entityActions.clearSearchStreet());
            }
        );
    };

    handleSelectBuilding = (building) => (e) => {
        e.preventDefault();
        const self = this;

        const num = building.NumCalle || 0;

        // value = dirección (para abajo)
        const addressValue = `${building.NomCalle || ""} ${num}`.replace(/\s+/g, " ").trim();

        this.setState(
            {
                search: "",

                value: building.Nombre || "",

                route: building.NomCalle || "",
                street_number: num,
                hasStreet: true,

                x: building.Lat,
                y: building.Lng,
                streetId: building.CalleID || -1,
                buildingId: building.EdificioID || -1,

                open: false,
                googleCantFindStreetNumber: false
            },
            () => {
                self.props.onSuccessLocation({
                    x: self.state.x,
                    y: self.state.y,
                    value: addressValue,
                    route: building.NomCalle || "",
                    street_number: num,
                    streetId: building.CalleID || -1,
                    buildingId: building.EdificioID || -1,
                    buildingName: building.Nombre || ""
                });
                self.props.dispatch(entityActions.clearSearchStreet());
            }
        );
    };
    render() {
        const { search, googleCantFindStreetNumber } = this.state;
        const {
            errors,
            touched,
            isSubmitting,
            t,
            entityConfig,
            buildings
        } = this.props;
        // const { reqMapNewInc } = entityConfig || {};

        return (
            <div>
                { //showBuildings && !useGecorStreetEngine && 
                    <div>
                        <Form.Label>{t("newincident.p8")}</Form.Label>
                        <Form.Control
                            s={12}
                            icon="filter_3"
                            placeholder={t("location.building-placeholder")}
                            value={this.props.value || ""}
                            onChange={this.handleSearchStreet}
                            disabled={isSubmitting}
                            isInvalid={
                                !!errors.streetName ||
                                !!errors.streetOptions?.x ||
                                !!errors.streetOptions?.y
                            }
                            isValid={
                                touched.streetName &&
                                !errors.streetName &&
                                !errors.streetOptions?.x &&
                                !errors.streetOptions?.y
                            }
                        />
                        <Form.Control.Feedback type="invalid">
                            {errors.streetName}
                            {!errors.streetName && errors.streetOptions
                                ? errors.streetOptions?.x
                                : ""}
                        </Form.Control.Feedback>
                        <div className="custom-prediction-wrapper">
                            <Row className="buidingSearch">
                                <ListGroup variant="flush">
                                    {search && buildings &&
                                        buildings.map((building, id) => (
                                            <ListGroup.Item
                                                className="ayto"
                                                key={id}
                                                onClick={this.handleSelectBuilding(building)}
                                            >
                                                <span className="title">
                                                    {building.Nombre} - {building.NomCalle} {building.NumCalle}
                                                </span>
                                            </ListGroup.Item>
                                        ))}
                                    {search && (!buildings || buildings.length < 1) && <div>
                                        {t("newincident.noBuilding")}</div>
                                    }
                                </ListGroup>
                            </Row>
                        </div>

                        <LocationNumberConfirm
                            {...this.props}
                            googleCantFindStreetNumber={googleCantFindStreetNumber}
                            street_number={this.state.street_number}
                            open={this.state.open}
                            handleChange={this.handleChange("street_number")}
                            handleClose={this.handleClose()}
                        />
                    </div>
                }
            </div>
        );
    }
}

export default LocationBuildingEngine;
